import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Maintenance from "./pages/Maintenance";
import { MAINTENANCE_MODE } from "./config";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        {MAINTENANCE_MODE ? (
          <Maintenance />
        ) : (
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:slug" element={<ServicePage />} />
            </Routes>
          </BrowserRouter>
        )}
      </div>
    </HelmetProvider>
  );
}

export default App;
